/* eslint-disable no-param-reassign */
import * as logger from 'loglevel';
import { getRates } from '../../../_integrations/everymundo/rates';
import { histogramsToFlatFares } from '../../../_integrations/everymundo/utils/normalizeFareLikeData';
import { isSSR } from '@front10/utils';
import { withCommonPreloads } from './commons/commonRatesPreloads';

const preloadCustomPropsExecute = (cmpConfig, clientPromises, ssrPromises) => {
  return new Promise((resolve, reject) => {
    const {
      containerConfig: {
        settings: { integrationSettings, prePopulation, meta, pageContext }
      },
      name,
      simulateSSR
    } = cmpConfig;

    const filters = Object.assign({}, prePopulation, {});

    let promises = [];
    if (!isSSR(simulateSSR)) {
      promises = clientPromises;
    } else {
      ssrPromises.push(getRates(filters, integrationSettings, meta, pageContext));
      promises = ssrPromises;
    }

    Promise.all(promises)
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .then(([others, histograms]) => {
        cmpConfig.containerConfig.settings.getRates = getRates;
        cmpConfig.containerConfig.settings.initialHistograms = histograms;
        // Fares Schema Implementation -> https://everymundo.atlassian.net/browse/FC-1700
        cmpConfig.containerConfig.settings.normalizedFlatFaresForSchema = histogramsToFlatFares(
          histograms
        );
        resolve(cmpConfig);
      })
      .catch((err) => {
        logger.error(`PRELOAD_CUSTOM_PROPS: ${name}`, err);
        reject(err);
      });
  });
};

const preloadCustomProps = (cmpConfig) => {
  // HOC For all Common Preload Logic
  return withCommonPreloads(preloadCustomPropsExecute, cmpConfig);
};

export default preloadCustomProps;
